import {createContext, useContext} from 'react';
import {shallow} from 'zustand/shallow';
import {useStoreWithEqualityFn} from 'zustand/traditional';

import type {BackgroundTasksStore, BackgroundTasksStoreApi} from './types';

export const BackgroundTasksContext = createContext<BackgroundTasksStoreApi | null>(null);

export const useBackgroundTasksStore = <T>(
  selector: (state: BackgroundTasksStore) => T,
  equalityFn: (left: T, right: T) => boolean = shallow,
): T => {
  const store = useContext(BackgroundTasksContext);
  if (!store) throw new Error(`Missing StoreContext.Provider in the tree`);

  return useStoreWithEqualityFn(store, selector, equalityFn);
};
